<template>
    <div class="pdf">
        <Button-component buttonText="Распечатать" class="pdf-button" @click="exportPDF"/>
        <div class="pdf-box">
            <div ref="pdfOrder" class="order-pdf">
                <div :class="order.type === 'Памятник' ? 'monument__one-page' : ''">
                    <header class="pdf-header">
                        <div class="pdf-header__logo-container">
                            <img :src="image.logo" alt="Март" class="pdf-header__logo-container__logo">
                        </div>
                        <div class="pdf-header__text-container">
                            <span class="pdf-header__text" v-if="order.creatorContacts?.fullname"><b>Исполнитель</b>{{order.creatorContacts?.fullname}}</span>
                            <span class="pdf-header__text" v-if="order.information.manager"><b>Менеджер</b>{{order.information.manager}}</span>
                            <span class="pdf-header__text" v-if="order.letter"><b>Пункт приема заказа</b>{{order.letter}}</span>
                        </div>
                    </header>
                    <main class="pdf-main">
                        <section class="pdf-hero">
                            <div class="pdf-col">
                                <h1 v-if="order.type === 'Благоустройство могил'" class="pdf-hero__title">Наряд-заказ на благоустройство могилы<span>{{order.number}}</span></h1>
                                <h1 v-if="order.type === 'Памятник'" class="pdf-hero__title">Наряд-заказ на гранитное изделие <span>{{order.number}}</span></h1>
                            </div>
                            <div class="pdf-col">
                                <span class="pdf-hero__date"><b>Дата приёма</b>{{new Date(order?.dates.startAt).toLocaleDateString()}}</span>
                                <span class="pdf-hero__date"><b>Дата выполнения</b>{{new Date(order?.dates.endAt).toLocaleDateString()}}</span>
                            </div>
                        </section>
                        <section v-if="order.type === 'Благоустройство могил'" class="pdf-information">
                            <div class="pdf-col">
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Ф.И.О. заказчика</span>
                                    <span class="pdf-information__text">{{order?.information.client}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Адрес</span>
                                    <span class="pdf-information__text">{{order?.information.clientAddress}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Ф.И.О. покойного</span>
                                    <span class="pdf-information__text">{{order?.information.deceased}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Место установки</span>
                                    <span class="pdf-information__text">{{order?.information.cemetery}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Участок</span>
                                    <span class="pdf-information__text">{{order?.information.graveDistrict}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Ряд</span>
                                    <span class="pdf-information__text">{{order?.information.graveRow}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Место</span>
                                    <span class="pdf-information__text">{{order?.information.gravePlace}}</span>
                                </div>
                            </div>
                        </section>
                        <section v-if="order.type === 'Памятник'" class="pdf-information__one-page">
                            <div class="pdf-col">
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Ф.И.О. заказчика</span>
                                    <span class="pdf-information__text">{{order?.information.client}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Телефон</span>
                                    <span class="pdf-information__text">{{order?.information.clientPhone}}</span>
                                </div>
                                <div v-if="order?.information.clientAddress" class="pdf-information__item">
                                    <span class="pdf-information__title">Адрес</span>
                                    <span class="pdf-information__text">{{order?.information.clientAddress}}</span>
                                </div>
                            </div>
                            <div class="pdf-col deceased">
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Ф.И.О. покойного</span>
                                    <span class="pdf-information__text">{{order?.information.deceased}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Дата рождения</span>
                                    <span class="pdf-information__text">{{new Date(order?.information.birthDate).toLocaleDateString()}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Дата смерти</span>
                                    <span class="pdf-information__text">{{new Date(order?.information.deathDate).toLocaleDateString()}}</span>
                                </div>
                            </div>
                            <div class="pdf-col cemetery">
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Место установки</span>
                                    <span class="pdf-information__text">{{order?.information.cemetery}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Участок</span>
                                    <span class="pdf-information__text">{{order?.information.graveDistrict}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Ряд</span>
                                    <span class="pdf-information__text">{{order?.information.graveRow}}</span>
                                </div>
                                <div class="pdf-information__item">
                                    <span class="pdf-information__title">Место</span>
                                    <span class="pdf-information__text">{{order?.information.gravePlace}}</span>
                                </div>
                            </div>
                        </section>
                        <section v-if="order.type === 'Благоустройство могил'" class="pdf-service">
                            <table class="pdf-table">
                                <thead class="pdf-table__head">
                                    <tr class="pdf-table__item">
                                        <th class="pdf-table__title pdf-table__title_7">№</th>
                                        <th class="pdf-table__title pdf-table__title_33">Наименование услуги</th>
                                        <th class="pdf-table__title pdf-table__title_15">Размер</th>
                                        <th class="pdf-table__title pdf-table__title_15">Ед. изм.</th>
                                        <th class="pdf-table__title pdf-table__title_15">Цена за ед., ₽</th>
                                        <th class="pdf-table__title pdf-table__title_15">Сумма, ₽</th>
                                    </tr>
                                </thead>
                                <tbody class="pdf-table__body">
                                    <tr class="pdf-table__item" v-for="service, index in order?.services">
                                        <td class="pdf-table__text">{{index + 1}}</td>
                                        <td class="pdf-table__text">{{service.title}}</td>
                                        <td class="pdf-table__text">{{service.quantity}}</td>
                                        <td class="pdf-table__text">{{service.measurement}}</td>
                                        <td class="pdf-table__text">{{new Intl.NumberFormat('ru-RU').format(service.cost)}}</td>
                                        <td class="pdf-table__text">{{new Intl.NumberFormat('ru-RU').format(service.price)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <section v-if="order.type === 'Памятник'" class="pdf-service__one-page">
                            <table>
                                <thead>
                                    <tr>
                                        <th colspan="2">Наименование услуги</th>
                                        <th>Размер</th>
                                        <th>Количество</th>
                                        <th>Сумма, ₽</th>
                                    </tr>
                                </thead>
                                <tbody v-for="servicesType, key in servicesTypes" :key="key">
                                    <tr class="table-header">
                                        <td colspan="4">{{servicesType}}</td>
                                        <td>{{getCurrentTypePrice(servicesType)}}</td>
                                    </tr>
                                    <tr v-for="service, index in getCurrentServiceType(servicesType)" :key="index">
                                        <td>{{index + 1}}</td>
                                        <td>{{service.title}} <span>{{getCurrentServiceProperties(service)}}</span></td>
                                        <td>{{service.size ? service.size : '-'}}</td>
                                        <td>{{service.quantity ? service.quantity : '1'}}</td>
                                        <td>{{new Intl.NumberFormat('ru-RU').format(service.price)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <section class="pdf-description" v-if="order.type === 'Благоустройство могил' && (order?.moreServices || order?.comment)">
                            <div class="pdf-col">
                                <h2 class="pdf-description__title" v-if="order?.moreServices">Дополнительные услуги</h2>
                                <p class="pdf-description__text">{{order?.moreServices}}</p>
                            </div>
                            <div class="pdf-col">
                                <h2 class="pdf-description__title" v-if="order?.comment">Комментарии к заказу</h2>
                                <p class="pdf-description__text">{{order?.comment}}</p>
                            </div>
                        </section>
                        <section v-if="order.type === 'Благоустройство могил'" class="pdf-payment">
                            <div class="pdf-col">
                                <div class="pdf-payment__item">
                                    <span class="pdf-payment__title pdf-payment__title_min">Итоговая сумма заказа</span>
                                    <span class="pdf-payment__number pdf-payment__number_gold">{{order?.price.final}}</span>
                                </div>
                                <div class="pdf-payment__item">
                                    <span class="pdf-payment__title pdf-payment__title_min">Тип оплаты</span>
                                    <span class="pdf-payment__number pdf-payment__number_small">{{prepay === 0 ? 'без предоплаты' : remains === 0 ? 'полный расчёт' : 'авансовый платёж'}}</span>
                                </div>
                                <div class="pdf-payment__item" v-if="order?.payments">
                                    <span class="pdf-payment__title pdf-payment__title_min">Аванс в размере</span>
                                    <span class="pdf-payment__number">{{prepay}}</span>
                                </div>
                                <div class="pdf-payment__item">
                                    <span class="pdf-payment__title pdf-payment__title_min">Остаток</span>
                                    <span class="pdf-payment__number">{{remains}}</span>
                                </div>
                            </div>
                            <div class="pdf-col">
                                <h2 class="pdf-payment__title">Подпись заказчика</h2>
                                <img class="pdf-payment__image" :src="order?.signImage" alt="" width="280" height="300">
                            </div>
                        </section>
                        <section v-if="order.type === 'Памятник'" class="pdf-bottom__one-page">
                            <div class="pdf-col">
                                <div class="pdf-payment__item">
                                    <span class="pdf-payment__title pdf-payment__title_min">Срок окончания работ</span>
                                    <span class="pdf-payment__number pdf-payment__number_small">{{new Date(order?.dates.endAt).toLocaleDateString()}}</span>
                                </div>
                                <div class="pdf-payment__item">
                                    <span class="pdf-payment__title pdf-payment__title_min">Итоговая сумма заказа</span>
                                    <span class="pdf-payment__number pdf-payment__number_gold">{{order?.price.final}} ₽</span>
                                </div>
                                <div class="pdf-payment__item">
                                    <span class="pdf-payment__title pdf-payment__title_min">Тип оплаты</span>
                                    <span class="pdf-payment__number pdf-payment__number_small">{{prepay === 0 ? 'без предоплаты' : remains === 0 ? 'полный расчёт' : 'авансовый платёж'}}</span>
                                </div>
                                <div class="pdf-payment__item" v-if="order?.payments">
                                    <span class="pdf-payment__title pdf-payment__title_min">Аванс в размере</span>
                                    <span class="pdf-payment__number">{{prepay}} ₽</span>
                                </div>
                                <div class="pdf-payment__item">
                                    <span class="pdf-payment__title pdf-payment__title_min">Остаток</span>
                                    <span class="pdf-payment__number">{{remains}} ₽</span>
                                </div>
                            </div>
                            <div class="pdf-col">
                                <h2 class="pdf-description__title" v-if="order?.moreServices">Дополнительные услуги</h2>
                                <p class="pdf-description__text">{{order?.moreServices}}</p>
                            </div>
                            <div class="pdf-col">
                                <h2 class="pdf-description__title" v-if="order?.comment">Комментарии к заказу</h2>
                                <p class="pdf-description__text">{{order?.comment}}</p>
                            </div>
                            <div class="pdf-col">
                                <h2 class="pdf-payment__title">Подпись заказчика</h2>
                                <img class="pdf-payment__image" :src="order?.signImage" alt="" width="280" height="300">
                            </div>
                        </section>
                    </main>
                    <footer v-if="order.type === 'Благоустройство могил'" class="pdf-footer">
                        <p class="pdf-footer__text">В случае не расчёта за произведённую работу исполнитель имеет право на демонтаж данного сооружения.</p>
                        <p class="pdf-footer__text">Гарантия на установку (бетонные работы) — 12 месяцев.</p>
                        <p class="pdf-footer__text">Заказчику запрещается проверять на прочность установленный исполнителем памятник до полной сдачи работы. В противном случае гарантия аннулируется.</p>
                    </footer>
                    <footer v-if="order.type === 'Памятник'" class="pdf-footer">
                        <p class="pdf-footer__text__normal">С эскизом согласен(на), материал осмотрен, претензий не имею ____________________ подпись ____________________</p>
                        <p class="pdf-footer__text__normal">Аванс принял(а) ____________________ подпись ____________________</p>
                        <p class="pdf-footer__text__normal">Заказ принял(а) ____________________ подпись ____________________</p>
                        <p class="pdf-footer__text__normal">Памятник принят. Претензий не имею. ____________________ дата ____________________ подпись ____________________</p>
                    </footer>
                </div>
            </div>
            <div v-if="order.uploadFiles" ref="pdfFiles" class="pdf-files">
                <img v-for="file, key in order.uploadFiles" :key="key" :src="getFilePath(file)" :data-alias="key" class="pdf_break-img">
            </div>
        </div>
    </div>
 </template>
<script setup lang="ts">
// @ts-ignore
import html2pdf from 'html2pdf.js'
import { computed, onMounted, PropType, ref } from 'vue'
import logo from '../assets/img/svg/logo.svg'
import sign from '../assets/img/Vector 1.png'
import { Order, OrderService, OrderFiles } from '../app/lib/types/orders'
import ButtonComponent from '../shared/buttonComponent.vue'
import { useLoadingStore } from '../app/store/store'
import toast from '../app/lib/hooks/errorToast'

const props = defineProps({
    order: {
        type: Object as PropType<Order>,
        required: true,
    },
})

const image = {
    logo,
    sign
}

const servicesTypes = new Set(props.order.services.map((item) => item.type))

function getCurrentServiceType(type: string | undefined) {
    return props.order.services?.filter((item) => item.type === type)
}

function getCurrentTypePrice(type: string | undefined) {
    if (type) {
        let price = 0
        getCurrentServiceType(type)?.forEach((item) => {
            price += item.price
        })
        return new Intl.NumberFormat('ru-RU').format(price)
    } else {
        return 0
    }
}

function getCurrentServiceProperties(service: OrderService) {
    let properties = []
    const startBracket = '('
    const endBracket = ')'
    if (service.color) {
        properties.push(service.color)
    }
    if (service.monumentNumber) {
        properties.push(service.monumentNumber)
    }
    if (service.polish) {
        properties.push(service.polish)
    }
    if (service.chamfer) {
        properties.push(service.chamfer)
    }
    if (service.anotherMonument) {
        properties.push(service.anotherMonument)
    }
    if (service.sandblastingNumber) {
        properties.push('№' + service.sandblastingNumber)
    }
    if (service.sandblastingPageNumber) {
        properties.push('стр.' + service.sandblastingPageNumber)
    }
    if (service.epitaph) {
        properties.push(service.epitaph)
    }
    if (service.font) {
        properties.push(service.font)
    }
    if (service.portrait) {
        properties.push(service.portrait)
    }
    if (service.retouch) {
        properties.push(service.retouch)
    }
    if (service.artworkNumber) {
        properties.push('№' + service.artworkNumber)
    }
    if (service.artworkPageNumber) {
        properties.push('стр.' + service.artworkPageNumber)
    }
    if (service.anotherArtwork) {
        properties.push(service.anotherArtwork)
    }
    if (service.anotherArtworkRetouch) {
        properties.push(service.anotherArtworkRetouch)
    }
    if (service.monumentModel) {
        properties.push(service.monumentModel)
    }
    if (service.porcelainModel) {
        properties.push(service.porcelainModel)
    }
    if (service.metalPhoto) {
        properties.push(service.metalPhoto)
    }
    if (service.fastener) {
        properties.push('Крепеж: ' + service.fastener)
    }
    if (service.enamelModel) {
        properties.push('Макет эмали: ' + service.enamelModel)
    }
    if (properties.length > 0) {
        return startBracket.concat(properties.join(', '), endBracket)
    } else {
        return
    }
}

const prepay =  props.order?.payments.reduce((sum, item) => {return sum + item.amount}, 0)

const remains: number | undefined = props.order?.price.final - prepay

function getFilePath(file: OrderFiles) {
    return import.meta.env.VITE_BACKEND + file.path
}

const opt = {
    margin: 30,
    filename: `${props.order?.information.client} + `,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, logging: true, dpi: 192, letterRendering: true, width: 1920, windowWidth: 1920, useCORS: true },
    jsPDF: { unit: 'px', format: 'a4', orientation: 'portrait', hotfixes: ["px_scaling"] },
    pagebreak: { mode: ['css'] }
}

const pdfOrder = ref(null)
const pdfFiles = ref(null)
const loading = useLoadingStore()

async function exportPDF() {
    loading.loading()
    //@ts-ignore
    await html2pdf().set(opt).from(pdfOrder.value).toPdf().get('pdf').then((doc) => {
        if (pdfFiles.value) {
            //@ts-ignore
            for (const node of pdfFiles.value.children) {
                const orientation = node.width < node.height ? 'portrait' : 'landscape'
                doc.addPage([node.width, node.height], orientation)
                doc.addImage(node, node.currentSrc.split('.').pop(), 0, 0, node.width, node.height, node.dataset.alias, 'NONE', 0)
            }
        }
    }).save()
    loading.load()
    toast('success', 'Документ сформирован')
}
</script>